module.exports = __webpack_public_path__ + "img/2.89881530.png";